import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { get } from "../config/api";
import LandingConnector from "../Landing/Connector/LandingConnector";
import MachineLayout from "../Layout/MachineLayout";
import { errorNotification } from "../Generic/Notifications";
import Page from "../Generic/Page";
import Loader from "../Generic/Loader";

const MachineRoute = (props) => {
	const auth = props.login;
	const { machineId } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const [error, setError] = useState(false);

	async function getMachines() {
		const response = await get({ url: "/v1/dashboard/restaurant/all" });
		const { data, error } = response;
		if (data) {
			const  machineData = data.find((item) => item._id === machineId);
			if (!machineData) {
				navigate("/404", { replace: true });
				return;
			}
			props.setMachineID(machineData);
			setError(false);
		}
		if (error) {
			setError(true);
		}
	}

	useEffect(() => {
		if (auth) getMachines();
		else if(auth === false) {
			navigate('/login', { state:{ redirectTo: location.pathname } });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth]);

	if(auth === undefined) {
		return (
			<Page>
	
			</Page>
		);
	}

	if (auth) {
		if (props.machineID !== "") {
			return (
				<MachineLayout>
					<Outlet />
				</MachineLayout>
			);
		}
		if (error) {
			return <Navigate to={"/404"} replace />;
		}
	}
};

export default LandingConnector(MachineRoute);
